@keyframes shimmer {
  from {
    background-position: 100% 0;
  }
}

/* Base shimmer effect - text variant (default) */
.shimmer {
  --speed: var(--shimmer-speed, 200);
  --spread: var(--shimmer-spread, calc(4ch + 80px));
  --bg: currentColor;
  --fg: var(--shimmer-color, oklch(from currentColor max(0.8, calc(l + 0.4)) c h / calc(alpha + 0.4)));

  --gradient-width: calc(var(--spread) + var(--shimmer-track-height, 200px) * tan(var(--shimmer-angle, 15deg)));
  --active-distance: calc(var(--shimmer-track-width, 200px) + var(--gradient-width));
  --duration: var(--shimmer-duration);
  --repeat-delay: var(--shimmer-repeat-delay, calc(20000 / var(--speed)));
  --repeat-delay-px: calc(var(--repeat-delay) * var(--active-distance) / var(--duration));
  --xy-offset-px: calc((var(--shimmer-x, 0) + var(--shimmer-y, 0) * tan(var(--shimmer-angle, 15deg))) * 1px);

  --bg-width: calc(100% + var(--shimmer-track-width, 100%) + var(--gradient-width) + var(--repeat-delay-px));

  --position: calc(
    var(--shimmer-track-width, (100% - var(--gradient-width) - var(--repeat-delay-px)) / 2) +
    var(--gradient-width) /
    2 +
    var(--repeat-delay-px) -
    var(--xy-offset-px)
  );

  /* Sine ease-in-out curve (17 stops) for smooth falloff */
  --mix-96: color-mix(in oklch, var(--fg), var(--bg) 96%);
  --mix-83: color-mix(in oklch, var(--fg), var(--bg) 83%);
  --mix-67: color-mix(in oklch, var(--fg), var(--bg) 67%);
  --mix-50: color-mix(in oklch, var(--fg), var(--bg) 50%);
  --mix-33: color-mix(in oklch, var(--fg), var(--bg) 33%);
  --mix-17: color-mix(in oklch, var(--fg), var(--bg) 17%);
  --mix-4: color-mix(in oklch, var(--fg), var(--bg) 4%);
  display: inline-block;
  -webkit-text-fill-color: transparent;

  background:
    linear-gradient(
      calc(90deg + var(--shimmer-angle, 15deg)),
      var(--bg) calc(var(--position) - var(--spread) * 0.5),
      var(--mix-96) calc(var(--position) - var(--spread) * 0.44),
      var(--mix-83) calc(var(--position) - var(--spread) * 0.37),
      var(--mix-67) calc(var(--position) - var(--spread) * 0.31),
      var(--mix-50) calc(var(--position) - var(--spread) * 0.25),
      var(--mix-33) calc(var(--position) - var(--spread) * 0.19),
      var(--mix-17) calc(var(--position) - var(--spread) * 0.12),
      var(--mix-4) calc(var(--position) - var(--spread) * 0.06),
      var(--fg) var(--position),
      var(--mix-4) calc(var(--position) + var(--spread) * 0.06),
      var(--mix-17) calc(var(--position) + var(--spread) * 0.12),
      var(--mix-33) calc(var(--position) + var(--spread) * 0.19),
      var(--mix-50) calc(var(--position) + var(--spread) * 0.25),
      var(--mix-67) calc(var(--position) + var(--spread) * 0.31),
      var(--mix-83) calc(var(--position) + var(--spread) * 0.37),
      var(--mix-96) calc(var(--position) + var(--spread) * 0.44),
      var(--bg) calc(var(--position) + var(--spread) * 0.5)
    )
    0 0 / var(--bg-width) 100% no-repeat;

  background-clip: text;

  animation: shimmer 1s linear 0s infinite backwards;
  animation-duration: calc((var(--duration) + var(--repeat-delay)) * 1ms);
}

/* Background variant - shimmer over a surface instead of text */
.shimmer-background {
  --speed: var(--shimmer-speed, 1000);
  --spread: var(--shimmer-spread, 480px);
  --bg: transparent;
  --fg: var(--shimmer-color, oklch(from currentColor 0 c h / 0.3));
  -webkit-text-fill-color: unset;

  background-clip: border-box;
}

/* Inverted color scheme for text variant */
.shimmer-inverted:not(.shimmer-background) {
  --shimmer-color: oklch(from currentColor l c h / calc(alpha * 0.2));
}

/* Container query mode */
.shimmer-container {
  container-type: inline-size;
}

.shimmer-container .shimmer {
  --shimmer-track-width: 100cqw;
  --shimmer-track-height: max(100cqh, 50cqw, 200px);
}
